import {
  Box, Button, Dialog, DialogActions, DialogContent, DialogTitle,
  Divider, List, ListItem, ListItemText, Typography
} from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getReleaseNotes } from "../../utils/MetaService";
import { Release } from "../../models/AppVersion";

export type ReleaseNotesDialogProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
}

const ReleaseNotesDialog = (props: ReleaseNotesDialogProps) => {
  const { t } = useTranslation();
  const [releases, setReleases] = useState<Release[]>([]);

  useEffect(() => {
    if (props.open) {
      getReleaseNotes().then(setReleases);
    }
  }, [props.open]);

  return (
    <Dialog open={props.open} onClose={() => props.setOpen(false)} fullWidth maxWidth="xs">
      <DialogTitle>{t('whatsNew')}</DialogTitle>
      <DialogContent>
        {releases.length === 0 ? (
          <Typography variant="body2" color="text.secondary">{t('noReleaseNotes')}</Typography>
        ) : (
          releases.map((release, index) => (
            <Box key={release.version} sx={{ mb: index < releases.length - 1 ? 2 : 0 }}>
              <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1, mb: 0.5 }}>
                <Typography variant="subtitle2" fontWeight={700}>v{release.version}</Typography>
                {release.date && (
                  <Typography variant="caption" color="text.secondary">{release.date}</Typography>
                )}
              </Box>
              <List dense disablePadding>
                {release.notes.map((note, noteIndex) => (
                  <ListItem key={noteIndex} disablePadding sx={{ py: 0.25 }}>
                    <ListItemText primary={`• ${note}`} primaryTypographyProps={{ fontSize: '0.85rem' }} />
                  </ListItem>
                ))}
              </List>
              {index < releases.length - 1 && <Divider sx={{ mt: 2 }} />}
            </Box>
          ))
        )}
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={() => props.setOpen(false)}>{t('close')}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReleaseNotesDialog;
